import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/_components/CookieBanner/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/_components/display-modals/DisplayModals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/_components/DisplayToasts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/_components/Providers.tsx");
